<template>
  <v-card class="" height="100%">
    <v-card-title
      ><v-switch v-model="mode" :label="`${mode ? '新增' : '編輯'}`"></v-switch
    ></v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field
            label="日期 *"
            v-model="modifyData.online"
            placeholder="YYYY/MM/DD"
            outlined
            dense
            hide-details
          >
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-btn dark class="bg-main" @click="submit">提交</v-btn>
        </v-col>
      </v-row>
      <v-expansion-panels multiple class="mt-10-px">
        <v-expansion-panel
          v-for="(brief, index) in modifyData.briefs"
          :key="index"
        >
          <v-expansion-panel-header>
            <div class="d-flex">
              <v-btn
                icon
                color="#111"
                class="mr-8-px"
                @click.stop="removeData(brief, index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-select
                :items="types"
                item-value="text"
                class="mr-10-px w-80-px"
                v-model="brief.type"
                outlined
                dense
                auto-select-first
                hide-details
              ></v-select>
              <v-select
                class="mr-10-px w-120-px"
                :items="items"
                v-model="brief.level"
                label="Level"
                outlined
                dense
                auto-select-first
                hide-details
              ></v-select>
              <v-select
                v-if="brief.level !== 1"
                class="mr-10-px w-120-px"
                :items="grandparentList(brief, index)"
                v-model="brief.parentId"
                item-text="topic"
                item-value="menuId"
                label="上層節點"
                outlined
                dense
                auto-select-first
                hide-details
              ></v-select>
              <v-autocomplete
                label="節點"
                outlined
                dense
                auto-select-first
                hide-details
                :items="chapterList(brief.level, index)"
                item-value="menuId"
                item-text="text"
                v-model="brief.menuId"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content @click="resetData(item, index)">
                    <v-list-item-title
                      class="fz-16-px"
                      v-text="item.text"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-if="item.level > 1"
                      v-text="item.parentTopic.topic"
                    ></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </div>

            <v-btn
              class="mx-10-px text-lowercase"
              :href="brief.url"
              target="_blank"
              dark
              :title="brief.url"
            >
              超連結
            </v-btn>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="6">
                <v-textarea
                  auto-grow
                  outlined
                  hide-details
                  name="input-7-4"
                  label="中文"
                  v-model="brief.desc"
                ></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea
                  auto-grow
                  outlined
                  hide-details
                  name="input-7-4"
                  label="英文"
                  v-model="brief.descEn"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-btn
        dark
        block
        class="light-blue darken-1 mt-10-px"
        @click.stop="appendData()"
        >增加一筆</v-btn
      >
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'BriefEdit',

  data() {
    return {
      mode: true,
      parentMenuId: 0,
      types: [
        { text: '更新' },
        { text: '新增' },
        { text: '刪除' },
        { text: '修改' }
      ],
      items: [
        { text: '第 1 層', value: 1 },
        { text: '第 2 層', value: 2 },
        { text: '第 3 層', value: 3 },
        { text: '第 4 層', value: 4 }
      ],
      deleteData: { briefId: [] },
      modifyData: {
        online: moment().format('YYYY/MM/DD'),
        briefs: []
      },
      modifyListObj: {
        desc: '',
        descEn: '',
        level: 1,
        menuId: 0,
        url: '',
        type: '更新',
        parentId: 0
      }
    }
  },

  computed: {
    ...mapState('common', ['modifyMode']),
    ...mapState('document', [
      'allChapterList',
      'createMode',
      'currEditObj',
      'versionData'
    ]),
    ...mapGetters('document', {
      mapActiveMenuListByLv: 'getActiveMenuListByLv'
    })
  },

  watch: {
    'modifyMode.show'(newVal) {
      this.deleteData.briefId = []
      this.modifyData.briefs = []
      if (newVal) {
        this.modifyData.briefs.push(
          JSON.parse(JSON.stringify(this.modifyListObj))
        )
      }
    },
    currEditObj: {
      handler: function (newVal) {
        if (this.createMode === 0) {
          this.mode = false
          // newVal.briefs.map((item) => {
          //   item.parentId = 0
          //   return item
          // })
          this.modifyData = newVal
        }
      },
      deep: true,
      immediate: true
    },
    mode(newVal) {
      this.deleteData.briefId = []
      if (newVal) {
        this.setCreateMode({ obj: {}, mode: -1 })
        this.modifyData.briefs = []
        this.modifyData.briefs.push(
          JSON.parse(JSON.stringify(this.modifyListObj))
        )
      } else {
        const data = Object.values(this.versionData)[0]
        const newData = { online: data[0].online, briefs: data }
        this.setCreateMode({ obj: newData, mode: 0 })
      }
    }
  },

  methods: {
    ...mapActions('message', ['setSnackbar']),
    ...mapActions('document', ['setCreateMode', 'setCurrentContent']),
    grandparentList(brief) {
      let arr = [{ menuId: 0, topic: '全部' }]
      const level = brief.level
      const data = JSON.parse(JSON.stringify(this.mapActiveMenuListByLv))
      for (const i in data) {
        const lv = parseInt(i.split('_')[0])
        if (lv === level - 1) {
          arr = arr.concat(
            data[i].sort(function (a, b) {
              return a.sn > b.sn ? 1 : -1
            })
          )
        }
      }
      return arr
    },
    resetData(item, index) {
      const { briefs } = this.modifyData
      briefs[index].url = item.url
    },
    chapterList(level, index) {
      const data = JSON.parse(JSON.stringify(this.allChapterList)).filter(
        (item) => item.menuId !== 1
      )
      const currData = this.modifyData.briefs[index]

      const parentMenuId = currData.parentId

      const contentData = {}
      for (const i in data) {
        const curr = data[i]
        curr.parentTopic = data.find((item) => item.menuId === curr.parentId)
        curr.text = curr.topic
        curr.url = this.mapUrl(curr)

        if (!contentData['dataLv' + curr.level]) {
          contentData['dataLv' + curr.level] = []
        }
        contentData['dataLv' + curr.level].push(curr)
      }

      const newData = contentData['dataLv' + level]
        .filter(
          (item) =>
            level === 1 || parentMenuId === 0 || item.parentId === parentMenuId
        )
        .sort((a, b) => {
          return a.sn > b.sn ? -1 : 1
        })

      if (
        currData.menuId === 0 ||
        !newData.find((item) => item.menuId === currData.menuId)
      ) {
        const currMenu = newData[0] ? newData[0] : { menuId: 0, url: '' }
        this.modifyData.briefs[index].menuId = currMenu.menuId
        this.modifyData.briefs[index].url = currMenu.url
      }

      return newData
    },
    mapUrl(menu) {
      let url = '/document?menuId='
      if (menu.level < 3) {
        url += menu.menuId
      } else if (menu.parentTopic.level < 3) {
        url += menu.parentTopic.menuId
      } else if (menu.parentTopic.level > 2) {
        const menuObj = this.allChapterList.find(
          (item) => item.menuId === menu.parentTopic.parentId
        )
        url += menuObj.menuId
      }
      const refKey =
        '&ref=leaf_' + menu.level + '_' + menu.parentId + '_' + menu.menuId
      url += refKey
      return url
    },
    removeData(item, index) {
      if (!this.mode) {
        this.deleteData.briefId.push(item.briefId)
      }

      this.modifyData.briefs.splice(index, 1)
    },
    appendData() {
      const { modifyListObj } = this
      this.modifyData.briefs.push(JSON.parse(JSON.stringify(modifyListObj)))
    },
    submit() {
      let data = this.modifyData
      const { briefs, online } = data
      if (online === '') {
        this.setSnackbar({
          show: true,
          text: '日期不可為空。',
          type: 'text',
          timeout: '1200'
        })
        return
      }

      for (const i in briefs) {
        const curr = briefs[i]
        delete curr.parentId
        if (curr.menuId === 0) {
          this.setSnackbar({
            show: true,
            text: '節點不可為空。',
            type: 'text',
            timeout: '1200'
          })
          return
        }
      }

      let key = 'create'
      if (this.createMode === 0) {
        key = 'modify'

        const newData = briefs.filter((item) => !item.briefId)
        const editData = briefs.filter((item) => item.briefId)

        data = {
          briefs: editData.map((item) => {
            item.online = online
            return item
          })
        }
        if (newData.length > 0) {
          this.$api.common.brief.create({ online, briefs: newData })
        }
      }

      if (this.deleteData.briefId.length > 0) {
        this.$api.common.brief.remove(this.deleteData)
      }

      this.$api.common.brief[key](data).then((e) => {
        this.setInit()
      })
    },
    setInit() {
      // this.setCreateMode({ obj: {}, mode: -1 })
      this.$api.common.brief.getLatest({}).then((res) => {
        this.setSnackbar({
          show: true,
          text: 'SUCCESS',
          timeout: '1200'
        })
        const briefs = res
          .filter((item) => item.online === this.modifyData.online)
          .map((item) => {
            const currMenu = this.allChapterList.find(
              (menu) => item.menuId === menu.menuId
            )
            item.level = currMenu.level
            return item
          })
        const data = {
          online: this.modifyData.online,
          briefs: briefs
        }
        this.deleteData.briefId = []
        this.setCreateMode({ obj: data, mode: 0 })
        this.setCurrentContent(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
